import { toastState } from "@/atoms/system/toast-state";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { CheckOutlineIcon } from "../icon/CheckOutlineIcon";
import { Body16Medium } from "../typography/Body16Medium";

interface Props {}

export const CustomToast: React.FC<Props> = ({}) => {
  const [toast, setToast] = useRecoilState(toastState);

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({
          show: false,
          messages: [],
          icon: undefined,
        });
      }, 3000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [toast]);

  return (
    <>
      {toast.show && (
        <div className="fixed top-[64px] left-[224px] right-0 bottom-0 flex items-center justify-center z-50 pointer-events-none">
          <div className="flex flex-col w-[240px] h-[152px] bg-grayscale-contrast-80 rounded-[6px] gap-[12px] items-center justify-center pointer-events-auto">
            <div className="flex justify-center items-center w-[32px] h-[32px] rounded-[8px] bg-primary-white">
              {toast.icon ? toast.icon : <CheckOutlineIcon />}
            </div>
            <div className="flex flex-col items-center">
              {toast.messages.map((message) => (
                <Body16Medium className="text-primary-white">
                  {message}
                </Body16Medium>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
